import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=35511800&scoped=true&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=35511800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35511800",
  null
  
)

export default component.exports